<template>
  <div class="w-full">
    <div
      class="items-center border-b border-b-mid-neutral-50 px-6 sticky top-0 left-0 z-50 bg-white"
    >
      <Tabs
        v-model:tab="activeStep"
        :tabs="tabs"
        :style="2"
        class="bg-white z-[51]"
      />
    </div>

    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script lang="ts" setup>
import Tabs from '@app/components/Global/Tabs/Tabs.vue'
import { computed } from 'vue'
import { PlanStep } from '../review.types'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()

const activeStep = computed({
  get: () => {
    if (route.path.includes('/evaluators')) {
      return PlanStep.evaluators
    } else if (route.path.includes('/objective')) {
      return PlanStep.objective
    } else if (route.path.includes('/strategy')) {
      return PlanStep.strategy
    } else if (route.path.includes('/appraisal')) {
      return PlanStep.appraisal
    } else if (route.path.includes('/search')) {
      return PlanStep.importSources
    } else {
      return PlanStep.evaluators
    }
  },
  set: (value: PlanStep) => {
    if (value === PlanStep.evaluators) {
      router.push({ name: 'Review - Plan - Evaluators' })
    } else if (value === PlanStep.objective) {
      router.push({ name: 'Review - Plan - Objective' })
    } else if (value === PlanStep.strategy) {
      router.push({ name: 'Review - Plan - Strategy' })
    } else if (value === PlanStep.appraisal) {
      router.push({ name: 'Review - Plan - Appraisal' })
    } else if (value === PlanStep.importSources) {
      router.push({ name: 'Review - Plan - Search' })
    }
  },
})

const tabs = [
  {
    number: PlanStep.evaluators,
    title: 'Evaluators',
  },
  {
    number: PlanStep.objective,
    title: 'Objective',
  },
  {
    number: PlanStep.strategy,
    title: 'Strategy',
  },
  {
    number: PlanStep.appraisal,
    title: 'Appraisal',
  },
  {
    number: PlanStep.importSources,
    title: 'Search',
  },
]
</script>
